import { AnalyticsBrowser, type AnalyticsBrowserSettings } from '@segment/analytics-next';

const SEGMENT_CDN_SETTINGS: AnalyticsBrowserSettings['cdnSettings'] = {
  "integrations": {
    "Salesforce (Actions)": {
      "versionSettings": {
        "componentTypes": [],
      },
    },
    "Mixpanel (Actions)": {
      "versionSettings": {
        "componentTypes": [],
      },
    },
    "Segment.io": {
      "apiKey": import.meta.env.VITE_SEGMENT_WRITE_KEY,
      "unbundledIntegrations": [],
      "addBundledMetadata": true,
      "maybeBundledConfigIds": {},
      "versionSettings": {
        "version": "4.4.7",
        "componentTypes": [
          "browser",
        ],
      },
    },
  },
  "plan": {
    "track": {
      "__default": {
        "enabled": true,
        "integrations": {},
      },
    },
    "identify": {
      "__default": {
        "enabled": true,
      },
    },
    "group": {
      "__default": {
        "enabled": true,
      },
    },
  },
  "edgeFunction": {},
  "analyticsNextEnabled": true,
  "enabledMiddleware": {},
  "metrics": {
    "sampleRate": 0.1,
  },
  "legacyVideoPluginsEnabled": false,
  "remotePlugins": [],
};

export const segmentClient = new AnalyticsBrowser();

segmentClient.load({
  writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  cdnSettings: SEGMENT_CDN_SETTINGS,
},
{
  disable: import.meta.env.VITE_SEGMENT_ENABLED !== 'true',
  integrations: {
    All: false,
    'Mixpanel (Actions)': true,
    'Segment.io': true,
  },
})
  .catch((error) => {
    console.error('Failed loading segment client', error);
  });
